




import EventBus from '@/eventBus.js';
import MembershipUpdate from '../../../../Templates/Admin/Membership/MembershipUpdate/MembershipUpdate.vue';

export default {
    name: 'CoAdminMembersPlanUpdate',
    components: {
        MembershipUpdate,
    },
    data() {
        return {
            userId: this.$route.params.ID,
            userName: '',
        };
    },
    created() {
        this.userName = this.$t('labels.user');
        this.adminGetUserByID(this.userId);
    },
    methods: {
        adminGetUserByID(ID: string) {
            this.$store
                .dispatch('adminGetUserByID', ID)
                .then((response) => {
                    const user = response;

                    if (user.Profile && user.Profile.Name) {
                        this.userName = user.Profile.Name;
                    }
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('messages.userDataLoadFailed'),
                        Details: error.response.data,
                    };
                    EventBus.$emit('ERROR', message);
                });
        },
    },
};
